module.exports = __webpack_public_path__ + "static/be-social-c33954987a2ee05412d711fca58c0382.jpg";